import { cls } from "@fvilers/cls";
import { ComponentPropsWithRef } from "react";
import styles from "./LoadingSpinner.module.css";

type LoadingSpinnerProps = ComponentPropsWithRef<"svg">;

export function LoadingSpinner({ className, ...props }: LoadingSpinnerProps) {
  return (
    <svg
      className={cls(styles.LoadingSpinner, className)}
      viewBox="25 25 50 50"
      {...props}
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        r="20"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  );
}
